import React from 'react';
import { translate } from 'react-i18next';

import Logo from '../common/Logo';

const Item = ({ newsletter, number, t }) => (
  <div className="c-box c-box-primary u-margin-bottom">
    <a target="_blank" rel="noopener noreferrer" href={newsletter.url}>
      <div className="c-box-primary__box">
        <div className="c-box-primary__item">
          <div className="u-display-flex u-align-items-center u-justify-content-between">
            <div className="c-box-primary__text">
              <h4 className="u-margin-bottom-micro">
                {t('newsletter.itemTitle', { number })}
              </h4>
              <p className="u-weight-bold u-text-uppercase u-opacity-half u-font-size-small">
                <small>{newsletter.subject}</small>
              </p>
            </div>
            <div>
              <Logo width="80" className="u-opacity-half" />
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
);

export default translate()(Item);



// WEBPACK FOOTER //
// ./src/newsletters/Item.js